import { load } from 'poly-eshop4/eshop/ui/js/util';
import api from 'poly-eshop4/eshop/ui/js/container';

const handleCommentSubmit = ($el) => {
  const data = $el.serialize();
  load(
    $el,
    $.ajax({
      url: $el.attr('action'),
      data,
      method: 'POST',
    }),
    { errorClass: 'error' },
  );
};

$(document).on('submit', '[data-customer-item-reel-attribute]', (event) => {
  event.preventDefault();
  handleCommentSubmit($(event.target));
});

$('[data-customer-item-reel-attribute]').find('input').on('change', (event) => {
  event.preventDefault();
  handleCommentSubmit($(event.target).closest('form'));
});

$('[data-add-cart-position-cuttable]').on('submit', (event) => {
  event.preventDefault();

  const $form = $(event.target).closest('form');
  const $quantity = $form.find('[name="quantity"]');
  const $dimensionQuantity = $form.find('[name="dimension_quantity"]');

  const quantity = parseFloat($quantity.val());
  const dimensionQuantity = parseFloat($dimensionQuantity.val());

  if (quantity > dimensionQuantity) {
    const cartPosition = $form.data('add-cart-position-cuttable');
    if (!cartPosition) {
      console.error('data-add-cart-position-cuttable is missing or empty');
      return;
    }

    const escapedCartPosition = cartPosition.replace(/\./g, '\\.');
    const $modal = $(`#confirm_${escapedCartPosition}`);

    if ($modal.length === 0) {
      console.error(`No modal found with ID #confirm_${escapedCartPosition}`);
      api.addPosition($form, 'cart');
    } else {
      $modal.foundation('open');
    }
  } else {
    api.addPosition($form, 'cart');
  }
});

$('[data-add-cart-position-cuttable-confirm]').on('click', (event) => {
  event.preventDefault();
  const $modal = $(event.target).closest('.reveal');
  const $button = $(event.target);
  const $form = $(`[data-add-cart-position-cuttable="${$button.data('add-cart-position-cuttable-confirm')}"]`);
  api.addPosition($form, 'cart');
  $modal.foundation('close');
});
